var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column justify-center align-center",staticStyle:{"min-height":"50vh"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"50","color":"primary"}}),_c('div',{staticClass:"mt-4 text-caption font-weight-bold grey--text text--darken-3"},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }